module.exports = __webpack_public_path__ + "fa-icons-pro.eab4fd1147956cd256c4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fa-icons-pro.woff
// module id = ./src/assets/webfonts/fa-icons-pro.woff
// module chunks = main